import { useRef } from "react";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import CommonButtonSpinner from "../../CommonButtonSpinner/CommonButtonSpinner";
import { useDispatch } from "react-redux";
import { memberLoginAction } from "../../../Redux/Action/MemberPanelAction";
import MemberPanelAuth from "../../../Utilities/MemberPanelAuth";

function MemberLoginForm(props) {
  // hooks
  const loginBtnRef = useRef();
  const dispatch = useDispatch();
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  // form on submit
  const onSubmit = (data) => {
    // making payload
    const payload = {
      data: data,
      loginBtnRef,
    };

    dispatch(memberLoginAction(payload));
  };

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)}>
        {/* user name */}
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>
            Enter user name
            <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            className={errors.member_id ? "is-invalid" : ""}
            {...register("member_id", { required: true })}
          />
          {errors.member_id && (
            <small className="text-danger">
              {errors.member_id.type == "required" && "This field is required!"}
            </small>
          )}
        </Form.Group>

        {/* password */}
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>
            Enter password
            <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            className={errors.password ? "is-invalid" : ""}
            {...register("password", { required: true })}
          />
          {errors.password && (
            <small className="text-danger">
              {errors.password.type == "required" && "This field is required!"}
            </small>
          )}
        </Form.Group>

        {/* login button */}
        <Button ref={loginBtnRef} variant="primary" type="submit">
          Login
          <CommonButtonSpinner />
        </Button>
      </Form>
    </>
  );
}

export default MemberLoginForm;
